<template>
  <b-container class="preview_wrapper">
    <b-row class="below">
      <b-col sm="2" lg="2">문제코드</b-col>
      <b-col class="qcode"
        ><h3>{{ qcode }}</h3></b-col
      >
    </b-row>

    <b-row class="below">
      <b-col sm="2" lg="2">학습유형</b-col>
      <b-col>{{ std_type }}</b-col>
    </b-row>

    <!-- <b-row class="below">
      <b-col sm="2" lg="2">유형</b-col>
      <b-col>{{ grp_type_text }}</b-col>
    </b-row> -->

    <b-row class="below" v-if="std_type_code == '1'">
      <b-col sm="2" lg="2">문제유형</b-col>
      <b-col>구조분석</b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == '2'">
      <b-col sm="2" lg="2">문제유형</b-col>
      <b-col>{{ q_type }}</b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == '3'">
      <b-col sm="2" lg="2">문제유형</b-col>
      <b-col>독해</b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == '1'">
      <b-col sm="2" lg="2">지시문<br />(직독직해)</b-col>
      <b-col>
        {{ statement }}
      </b-col>
    </b-row>
    <b-row class="below" v-if="std_type_code == '1'">
      <b-col sm="2" lg="2">지시문<br />(구조분석)</b-col>
      <b-col>
        {{ statement4 }}
      </b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == '1'">
      <b-col sm="2" lg="2">지시문<br />(스크램블)</b-col>
      <b-col>
        {{ statement2 }}
      </b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == '1'">
      <b-col sm="2" lg="2">지시문<br />(영작)</b-col>
      <b-col>
        {{ statement3 }}
      </b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == '2' || std_type_code == '3'">
      <b-col sm="2" lg="2">공통 지시문</b-col>
      <b-col>{{ statement }}</b-col>
    </b-row>

    <PreviewSenType v-if="std_type_code == '1'" />

    <PreviewExplain
      v-if="grp_type == '2' && (std_type_code == '2' || std_type_code == '3')"
    />
    <PreviewQType1
      v-if="grp_type == '1' && (std_type_code == '2' || std_type_code == '3')"
    />

    <b-row class="below" v-if="grp_type == '1' && std_type_code == '2'">
      <b-col sm="2" lg="2">출제포인트</b-col>
      <b-col>
        <ul>
          <li>{{ intent }}</li>
          <li>{{ intent2 }}</li>
          <li>{{ intent3 }}</li>
        </ul>
      </b-col>
    </b-row>
    <template v-if="std_type_code == '1'">
      <b-row class="below">
        <b-col sm="2" lg="2">해설</b-col>
        <b-col v-html="qcomment"></b-col>
      </b-row>

      <PreviewVideos />
      <b-row class="below">
        <b-col sm="2" lg="2">음원</b-col>
        <b-col>{{ form.sound }}</b-col>
      </b-row>

      <b-row class="below" v-if="std_type_code == '2'">
        <b-col sm="2" lg="2">난이도</b-col>
        <b-col class="lvlwrapper" v-html="level"></b-col>
      </b-row>

      <b-row class="below" v-if="std_type_code == '1'">
        <b-col sm="2" lg="2">난이도</b-col>
        <b-col class="lvlwrapper" v-html="level"></b-col>
      </b-row>

      <b-row class="below" v-show="1 == 2">
        <b-col sm="2" lg="2">어휘</b-col>
        <b-col>{{ word_level_str }}</b-col>
      </b-row>
      <b-row class="below">
        <b-col sm="2" lg="2">기출정보</b-col>
        <b-col>{{ form.prevtest_info }}</b-col>
      </b-row>
    </template>

    <template
      v-if="grp_type == '2' && (std_type_code == '2' || std_type_code == '3')"
    >
      <PreviewGroupQType1
        class="grpcls"
        :question="q"
        :key="q.id"
        v-for="q in questions"
      />
    </template>
    <b-button
      class="float-right"
      style="margin-top: 10px"
      variant="primary"
      @click="modify()"
      >수정</b-button
    >
  </b-container>
</template>

<script>
import PreviewQType1 from "@/components/preview/PreviewQType1";
import PreviewSenType from "@/components/preview/PreviewSenType";
import PreviewGroupQType1 from "@/components/preview/PreviewGroupQType1";
import PreviewExplain from "@/components/preview/PreviewExplain";
import PreviewVideos from "@/components/preview/PreviewVideos";
import * as R from "ramda";
import { mapState } from "vuex";

export default {
  components: {
    PreviewQType1,
    PreviewExplain,
    PreviewVideos,
    PreviewGroupQType1,
    PreviewSenType,
  },
  computed: {
    ...mapState("senStore", ["senlvl_options"]),
    qcode() {
      return this.$store.state.questionmeta.qcode;
    },
    level() {
      let chgs = "";
      let lvs = this.$store.state.questionform.level;
      let lvl_options = this.$store.state.lvl_options;

      for (let i = 0; i < lvs.length; i++) {
        chgs +=
          "<div class='lvlbox'>" +
          R.find(R.propEq("value", lvs[i]))(lvl_options)["text"] +
          "</div>";
      }

      return chgs;
    },

    senlevel() {
      let lvs = this.$store.state.questionform.senlevel;
      if (lvs != "") {
        return R.find(R.propEq("value", lvs))(this.senlvl_options)["text"];
      } else {
        return "";
      }
    },
    word_level_str() {
      let lvs = this.$store.state.questionform.word_level;
      let word_options = this.$store.state.word_level_options;
      if (lvs != "") {
        return R.find(R.propEq("value", lvs))(word_options)["text"];
      } else {
        return "";
      }
    },

    form() {
      return this.$store.state.questionform;
    },
    intent() {
      let intent = this.$store.state.questionform.intent1;
      return `${intent.d1}->${intent.d2}->${intent.d3}`;
    },
    intent2() {
      let intent = this.$store.state.questionform.intent2;
      if (intent != null && intent != undefined && intent != "") {
        return `${intent.d1}->${intent.d2}->${intent.d3}`;
      } else {
        return "";
      }
    },
    intent3() {
      let intent = this.$store.state.questionform.intent3;
      if (intent != null && intent != undefined && intent != "") {
        return `${intent.d1}->${intent.d2}->${intent.d3}`;
      } else {
        return "";
      }
    },

    grp_type() {
      return this.$store.state.questionmeta.grp_type;
    },
    statement() {
      return this.$store.state.questionmeta.statement;
    },
    statement2() {
      return this.$store.state.questionmeta.statement2;
    },

    statement3() {
      return this.$store.state.questionmeta.statement3;
    },

    statement4() {
      return this.$store.state.questionmeta.statement4;
    },

    grp_type_text() {
      let txt = "";
      if (this.$store.state.questionmeta.grp_type == "1") {
        txt = "개별문항";
      } else {
        txt = "그룹문항";
      }

      return txt;
    },
    questions() {
      return this.$store.state.previews_questions;
    },
    std_type() {
      let txt = "";
      if (this.$store.state.questionmeta.std_type == "1") {
        txt = "문장훈련";
      } else if (this.$store.state.questionmeta.std_type == "2") {
        txt = "문풀훈련";
      } else if (this.$store.state.questionmeta.std_type == "3") {
        txt = "독해모의";
      }
      return txt;
    },
    std_type_code() {
      return this.$store.state.questionmeta.std_type;
    },
    q_type() {
      let txt = "";
      if (this.$store.state.questionform.q_type == "1") {
        txt = "서답형";
      } else if (this.$store.state.questionform.q_type == "2") {
        txt = "선택형";
      } else if (this.$store.state.questionform.q_type == "3") {
        txt = "선다형";
      } else if (this.$store.state.questionform.q_type == "4") {
        txt = "어순배열";
      } else if (this.$store.state.questionform.q_type == "5") {
        txt = "선택보기";
      } else if (this.$store.state.questionform.q_type == "6") {
        txt = "밑줄긋기";
      }
      return txt;
    },
    qcomment() {
      if (this.grp_type == "1") {
        return this.$store.state.questionmeta.qcomment;
      } else {
        return this.$store.state.questionmeta.qcomment;
      }
    },
  },
  methods: {
    modify() {
      let meta_id = this.$store.state.questionmeta.id;

      this.$store.commit("resetQuestionMeta");
      this.$store.commit("resetQuestionForm");
      this.$store.state.mode = "form";
      this.$store.dispatch("loadQuestionFullByMeta", meta_id);
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.preview_wrapper {
  background: white;
  border-radius: 5px;
  padding-top: 20px;
  // padding-bottom: 20px;
  font-size: 0.95em;
}
.below {
  padding-bottom: 6px;
  padding-top: 6px;
  border-bottom: 1px solid $gray100;
  img {
    max-width: 450px;
  }
}
.lvlbox {
  background-color: $gray100;
  font-weight: 700;
}

.lvlwrapper ::v-deep div {
  background-color: $point1;
  padding: 4px 6px 4px 6px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.9em;
  margin-right: 4px;
  color: $gray100;
  display: inline;
}
</style>